import React from 'react';

export const MetatheoryLogo = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5285_4543)">
        <path
          d="M12.0001 0.121094C5.43852 0.121094 0.120117 5.43949 0.120117 12.0011C0.120117 18.5627 5.43852 23.8811 12.0001 23.8811C18.5617 23.8811 23.8801 18.5627 23.8801 12.0011C23.8801 5.43949 18.5617 0.121094 12.0001 0.121094ZM15.9793 2.76109C18.1081 3.68149 19.8577 5.31589 20.9257 7.36189C14.6857 7.03909 12.8317 6.14869 12.1513 2.76109C12.0997 2.50189 12.0541 2.22829 12.0145 1.94029C13.4221 1.94149 14.7625 2.23429 15.9793 2.76109ZM8.02092 2.76109C9.23772 2.23429 10.5793 1.94149 11.9869 1.94029C11.9473 2.22949 11.9017 2.50309 11.8501 2.76109C11.1685 6.14869 9.31572 7.03789 3.07572 7.36189C4.14132 5.31589 5.89212 3.68149 8.02092 2.76109ZM12.0001 12.9251C8.48892 12.9251 5.36292 14.5691 3.34572 17.1275C2.45292 15.6251 1.93932 13.8719 1.93932 12.0011C1.93932 10.3439 2.34252 8.77909 3.05532 7.39909C9.85692 7.74949 11.4505 8.77189 12.0001 12.9251C12.0001 12.9251 12.0001 12.9155 12.0001 12.8975C12.0001 12.9155 12.0001 12.9251 12.0001 12.9251C12.5497 8.77189 14.1433 7.74949 20.9461 7.39909C21.6589 8.77909 22.0621 10.3439 22.0621 12.0011C22.0621 13.8719 21.5485 15.6251 20.6545 17.1275C18.6373 14.5691 15.5113 12.9251 12.0001 12.9251Z"
          fill="white"
          fillOpacity="0.4"
        />
      </g>
      <defs>
        <clipPath id="clip0_5285_4543">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
